import { requestJson } from '@/api/transport';
import { type PortalDeposit,portalDepositSchema } from '@/schemas/cashierSession.schema';
import { type CashierChooseBody } from '@/schemas/choose.schema';
import { type CashierMethods,cashierMethodsSchema } from '@/schemas/methods.schema';

export function getMethods(token: string, signal: AbortSignal): Promise<CashierMethods> {
  return requestJson(
    `/v1/cashier/${encodeURIComponent(token)}/methods`,
    { method: 'GET' },
    cashierMethodsSchema,
    signal,
  );
}

export function postChoose(
  token: string,
  body: CashierChooseBody,
  signal: AbortSignal,
): Promise<PortalDeposit> {
  return requestJson(
    `/v1/cashier/${encodeURIComponent(token)}/choose`,
    { method: 'POST', body },
    portalDepositSchema,
    signal,
  );
}
